import {
  View,
  Text,
  TouchableOpacity,
} from "react-native";
import React from "react";
import { SafeAreaView } from "react-native-safe-area-context";
import editProfileStyle from "../../../styles/editProfileStyle";
import settingsStyle from "../../../styles/settingsStyle";
import FeedIcons from "../../../../../assets/Icons/FeedIcons";
import GlobalStyles from "../../../../../globalStyles/globalStyles";
import CustomComponent from "../../../../../components/CustomComponent";


export default function EditName({ navigation,route}: { navigation: any, route:any }) {

  const { staticData, setStaticData }=route.params

  const handleFirstNameChange = (text: string) => {
    setStaticData((prev: any) => {
      return {
        ...prev,
        firstName: text
      };
    });
  };

  const handleLastNameChange = (text: string) => {
    setStaticData((prev: any) => {
      return {
        ...prev,
        lastName: text
      };
    });
  }


  return (
    <SafeAreaView
      style={{
        backgroundColor: "white",
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
      }}
    >
      <View style={editProfileStyle.stickTopBar}>
        <View style={editProfileStyle.backBoxMain}>
          <View style={[settingsStyle.backBox, {}]}>
            <TouchableOpacity onPress={() => navigation.goBack()}>
              <FeedIcons.BackIcon />
            </TouchableOpacity>
            <Text style={GlobalStyles.heading3}>Name</Text>
          </View>
        </View>
      </View>
      <View style={{ backgroundColor: "white", width: "90%", height: "90%" }}>
        <View style={{ marginTop: 30, height: 60, width: '100%' }}>
          <CustomComponent.InputField
            placeholder={"First name"}
            onTextChange={handleFirstNameChange}
            defaultValue={staticData.firstName}
          />
        </View>
        <Text style={[GlobalStyles.bodyText, { marginTop: 10 }]}>
            Always visible on profile
        </Text>
        <View style={{ marginTop: 30, height: 60, width: '100%' }}>
          <CustomComponent.InputField
            placeholder={"Last name"}
            onTextChange={handleLastNameChange}
            defaultValue={staticData.lastName}
          />
        </View>
      </View>
    </SafeAreaView>
  );
}
